"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var houston_styles_1 = require("@eduzz/houston-styles");
var Typography_1 = tslib_1.__importDefault(require("../../Typography"));
var ListText = function (_a) {
    var title = _a.title, description = _a.description, _b = _a.disableTypography, disableTypography = _b === void 0 ? false : _b, className = _a.className, rest = tslib_1.__rest(_a, ["title", "description", "disableTypography", "className"]);
    return ((0, jsx_runtime_1.jsxs)("div", tslib_1.__assign({ className: (0, houston_styles_1.cx)('hst-list-item-text', className) }, rest, { children: [!disableTypography ? ((0, jsx_runtime_1.jsx)(Typography_1.default, tslib_1.__assign({ size: 'xs', weight: 'semibold', lineHeight: 'lg' }, { children: title }))) : (title), !disableTypography && !!description ? ((0, jsx_runtime_1.jsx)(Typography_1.default, tslib_1.__assign({ size: 'xxs', weight: 'regular', lineHeight: 'md' }, { children: description }))) : (description)] })));
};
/**
 * @deprecated Use List from Antd
 * https://ant.design/components/list/
 */
exports.default = ListText;
